// extracted by mini-css-extract-plugin
module.exports = {"root":"ClearentDisclaimer_root__1KqTK","header":"ClearentDisclaimer_header__1KrFK","inner":"ClearentDisclaimer_inner__1TT1h"};